module.exports = __webpack_public_path__ + "img/7.a2d17951.webp";